export const adapterLink = (
  links: { id: number; url: string; label: string | null }[]
) => {
  return links.map((link) => {
    return {
      url: link.url,
      label: link.label || ""
    };
  });
};
